export * as Api from './api';
export var GrossOrNetFee;
(function (GrossOrNetFee) {
    GrossOrNetFee["Gross"] = "GROSS";
    GrossOrNetFee["Net"] = "NET";
})(GrossOrNetFee || (GrossOrNetFee = {}));
//# sourceMappingURL=index.js.map